module.exports = __webpack_public_path__ + "static/media/COS_DODIE.5c6a62b4.png";